/*
 * icb-rail.js — Initialise tous les rails produit INGCO (collection-with-banner).
 * Chargé une seule fois en defer depuis theme.liquid.
 * Remplace 18 x 8 KB de scripts inline -> 1 fichier caché de 8 KB.
 */
(function () {
  'use strict';

  function showToast(msg, isError) {
    var t = document.getElementById('icb-global-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'icb-global-toast';
      t.className = 'icb-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-visible');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2400);
  }

  var SECTION_IDS = ['header','cart-drawer','cart-notification','cart-icon-bubble',
    'mini-cart','ajax-cart-template','ajax-cart'];

  function refreshCartSections() {
    return fetch('/?sections=' + SECTION_IDS.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        Object.keys(json || {}).forEach(function (sectionId) {
          var newHtml = json[sectionId];
          if (!newHtml) return;
          var target = document.getElementById('shopify-section-' + sectionId);
          if (target) { target.innerHTML = newHtml; return; }
          var alt = document.querySelector('#' + sectionId + ', .' + sectionId + ', [data-section-id="' + sectionId + '"]');
          if (alt) alt.innerHTML = newHtml;
        });
      }).catch(function () {});
  }

  function updateCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var selectors = ['[data-cart-count]','.cart-count-bubble',
          '.cart-count-bubble span[aria-hidden="true"]','.site-header__cart-count',
          '.site-header__cart-count span','.cart-link__bubble',
          '.header__cart-count','#CartCount','#CartCount span','.js-cart-count'];
        document.querySelectorAll(selectors.join(',')).forEach(function (el) { el.textContent = count; });
        document.querySelectorAll('.cart-count-bubble, .site-header__cart-count').forEach(function (el) {
          if (count > 0) el.classList.remove('hidden', 'is-empty');
        });
        return cart;
      }).catch(function () {});
  }

  function fireThemeCartEvents(cart) {
    var events = ['cart:refresh','cart:build','cart:updated','cart:change',
      'ajaxProduct:added','ajaxCart.afterCartLoad','shopify:cart:add'];
    events.forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart }, bubbles: true })); } catch (e) {}
    });
    if (window.jQuery) {
      try { window.jQuery(document.body).trigger('ajaxCart.afterCartLoad', [cart]); } catch (e) {}
      try { window.jQuery(document.body).trigger('cart.requestComplete', [cart]); } catch (e) {}
    }
    try { if (window.theme && window.theme.cart && typeof window.theme.cart.buildCart === 'function') window.theme.cart.buildCart(); } catch (e) {}
    try { if (window.theme && window.theme.AjaxCart && typeof window.theme.AjaxCart.load === 'function') window.theme.AjaxCart.load(); } catch (e) {}
    try { if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') window.Shopify.onCartUpdate(cart); } catch (e) {}
  }

  function initIcbRail(root) {
    if (!root) return;

    var rail = root.querySelector('[data-icb-rail]');
    var prev = root.querySelector('[data-icb-prev]');
    var next = root.querySelector('[data-icb-next]');

    function step() {
      var first = rail && rail.querySelector('.icb-card');
      if (!first) return 300;
      return first.getBoundingClientRect().width + 14;
    }

    if (prev && rail) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next && rail) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); });

    root.querySelectorAll('[data-icb-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) { window.location.href = btn.getAttribute('data-product-url') || '/cart'; return; }
        var originalLabel = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Ajout...';
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }],
            sections: SECTION_IDS.join(','), sections_url: window.location.pathname })
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (data) {
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-added');
          btn.textContent = 'Ajoute au panier';
          showToast('Produit ajouté au panier');
          if (data && data.sections) {
            Object.keys(data.sections).forEach(function (sectionId) {
              var newHtml = data.sections[sectionId];
              if (!newHtml) return;
              var target = document.getElementById('shopify-section-' + sectionId);
              if (target) { target.innerHTML = newHtml; return; }
              var alt = document.querySelector('#' + sectionId + ', .' + sectionId + ', [data-section-id="' + sectionId + '"]');
              if (alt) alt.innerHTML = newHtml;
            });
          } else { refreshCartSections(); }
          updateCartCount().then(fireThemeCartEvents);
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = originalLabel; }, 2200);
        })
        .catch(function (err) {
          btn.removeAttribute('aria-busy');
          btn.textContent = originalLabel;
          var msg = (err && err.description) || (err && err.message) || 'Erreur - impossible d\'ajouter au panier';
          showToast(msg, true);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-icb-root]').forEach(initIcbRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
